// employeesApi.js
import { BASE_URL, HEADERS } from "./config";

/**
 * Disconnect all employees except the requesting admin
 * This invalidates all user sessions by changing their tokens
 * @param {string} adminEmail - Email of the admin performing the action
 * @returns {Promise<{success: boolean, message: string, data?: {disconnectedCount: number}}>}
 */
export const disconnectAllEmployees = async (adminEmail) => {
  const API_URL = BASE_URL + "/employees/disconnect-all";

  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: HEADERS,
      body: JSON.stringify({
        adminEmail: adminEmail.toLowerCase(),
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to disconnect employees: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error disconnecting employees:", error);
    return { 
      success: false, 
      message: error.message || "Failed to disconnect employees" 
    };
  }
};

